
import type { BaseErrorResponse, GetNrm2AdminSettingsRes, UpdateNrm2AdminSettingsReq } from './data-contracts';
import type { RequestParams } from './http-client';
import { ContentType, HttpClient } from './http-client';


export default function useNrm2() {
  class Nrm2<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags NRM 2
     * @name Nrm2AdminSettingsControllerGetSettings
     * @summary Returns NRM2 admin settings
     * @request GET:/api3/nrm2/admin-settings
     * @secure
     * @response `200` `GetNrm2AdminSettingsRes`
     * @response `400` `BaseErrorResponse`
     */
    nrm2AdminSettingsControllerGetSettings = (params: RequestParams = {}) =>
      this.request<GetNrm2AdminSettingsRes, BaseErrorResponse>({
        path: '/api3/nrm2/admin-settings',
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags NRM 2
     * @name Nrm2AdminSettingsControllerUpdateSettings
     * @summary Updates NRM2 admin settings
     * @request PUT:/api3/nrm2/admin-settings
     * @secure
     * @response `200` `GetNrm2AdminSettingsRes`
     * @response `400` `BaseErrorResponse`
     */
    nrm2AdminSettingsControllerUpdateSettings = (data: UpdateNrm2AdminSettingsReq, params: RequestParams = {}) =>
      this.request<GetNrm2AdminSettingsRes, BaseErrorResponse>({
        path: '/api3/nrm2/admin-settings',
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags NRM 2
     * @name Nrm2GlobalSettingsControllerGetSettings
     * @summary Returns NRM2 global settings
     * @request GET:/api3/nrm2/global-settings
     * @secure
     * @response `200` `GetNrm2AdminSettingsRes`
     * @response `400` `BaseErrorResponse`
     */
    nrm2GlobalSettingsControllerGetSettings = (params: RequestParams = {}) =>
      this.request<GetNrm2AdminSettingsRes, BaseErrorResponse>({
        path: '/api3/nrm2/global-settings',
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags NRM 2
     * @name Nrm2GlobalSettingsControllerUpdateSettings
     * @summary Updates NRM2 global settings
     * @request PUT:/api3/nrm2/global-settings
     * @secure
     * @response `200` `GetNrm2AdminSettingsRes`
     * @response `400` `BaseErrorResponse`
     */
    nrm2GlobalSettingsControllerUpdateSettings = (data: UpdateNrm2AdminSettingsReq, params: RequestParams = {}) =>
      this.request<GetNrm2AdminSettingsRes, BaseErrorResponse>({
        path: '/api3/nrm2/global-settings',
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });
  }

  return new Nrm2();
}
